import VuexPersist from 'vuex-persist';

const vuexUserStorage = new VuexPersist({
  key: 'user-storage',
  storage: window.localStorage,

  modules: [
    'authorization',
  ],
  restoreState: (key, storage) => storage[key],
});

export default vuexUserStorage;
